export default {
  filter: 'saturate(0.2) contrast(0.8)'
};
//# sourceMappingURL=filterStyle.js.map